import service, { type HttpResponseSuccess } from './service';

const apiService = service(`${process.env.REACT_BACKEND_HOST}`);

export type CategorySuggestionsResponse = HttpResponseSuccess<string[]>;

export const getCategorySuggestions = (
	prefix: string
): Promise<CategorySuggestionsResponse> =>
	apiService.get('/api/business/categories/suggest', { params: { prefix } });
